import { mapActions, mapGetters } from 'vuex'

export default {
  methods: {
    ...mapActions('tenderResult', [
      'loadData',
      'loadDataTenderResultCard'
    ])
  },
  computed: {
    ...mapGetters('tenderResult', [
      'getTenderResult',
      'getLoadingTenderResult',
      'getLoadedTenderResult',
      'getTenderResultCard',
      'getLoadingTenderResultCard',
      'getLoadedTenderResultCard',
      'getValueImporto'
    ])
  }
}
